import { Typography } from 'antd';
import styles from './index.less';

const { Title, Paragraph, Text, Link } = Typography;
const NotFound = () => (
  <Typography className={styles.notFound}>
    <Title className={styles.title}>对不起</Title>
    <Paragraph className={styles.content}>
      您访问的页面不存在！
    </Paragraph>
  </Typography>
);

export default NotFound;
